module.exports = __webpack_public_path__ + "img/pause-audio-icon.d20776ca.svg";